// extracted by mini-css-extract-plugin
module.exports = {"rotation":"CodiceEticoTemplate_rotation__0V7_1"};